import { createFeatureSelector, createSelector } from '@ngrx/store';
import { MapState, selectAll } from '@states/map/map.reducer';

export const selectMapState =
  createFeatureSelector<MapState>('mapState');

export const selectAllMapObjects = createSelector(
  selectMapState,
  (state) => selectAll(state)
);
export const selectImageUrl = createSelector(
  selectMapState,
  ({ imageUrl }: MapState) => imageUrl,
);

export const selectIsLoading = createSelector(selectMapState, (state: MapState) => state.isLoading);
